export default {"src":"/fi/sahkoa/_next/static/media/media-not-found.a1bbf59b.svg","height":352,"width":343,"blurWidth":0,"blurHeight":0};